/* NEXperts – Scroll-Einblend-Animationen (robust: nichts bleibt je unsichtbar) */
(function () {
  "use strict";

  function init() {
    var els = document.querySelectorAll("[data-anim]");
    if (!els.length) return;

    function reveal(el) { el.classList.add("is-visible"); }

    if (!("IntersectionObserver" in window)) {
      els.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -5% 0px" });

    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      // Bereits im (nahe am) Viewport sichtbare Elemente sofort einblenden – z. B. Hero.
      if (el.getBoundingClientRect().top < vh * 0.98) {
        reveal(el);
      } else {
        io.observe(el);
      }
    });

    // Sicherheitsnetz: falls ein Element nie triggert, nach 1,5 s trotzdem einblenden.
    setTimeout(function () { els.forEach(reveal); }, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
